<template>
    <div class="page-login">
        <div class="login-panel">
            <div v-if="mode == 'account'">
                <form onsubmit="return false;" novalidate>
                    <div class="form-group" :class="{'has-error':errors.has('account')}">
                        <label class="control-label">账号：</label>
                        <div class="controls">
                            <input name="account" v-validate="rules.account" class="form-control" type="text"
                                   v-model="form.account" autocomplete="off">
                            <span v-show="errors.has('account')" class="error-message">{{ errors.first('account') }}</span>
                        </div>
                    </div>
                    <div class="form-group" :class="{'has-error':errors.has('password')}">
                        <label class="control-label">密码：</label>
                        <div class="controls">
                            <input name="password" v-validate="rules.password" class="form-control" type="password"
                                   v-model="form.password" autocomplete="off">
                            <span v-show="errors.has('password')" class="error-message">{{ errors.first('password') }}</span>
                        </div>
                    </div>
                    <div class="form-group">
                        <button type="submit" class="btn btn-block btn-primary" @click="loginByAccount" :disabled="isLoading">
                            登录
                        </button>
                    </div>
                    <div class="error-message text-center">
                        <label>{{status}}</label>
                    </div>
                </form>

                <div class="text-center">
                    <!--<a href="javascript:;" @click="mode = 'phone'">验证码登录</a>
                    <a href="javascript:;" @click="mode = 'qrcode'" style="margin-left:50px">微信扫码登录</a>-->
                </div>
            </div>
            <div v-else-if="mode == 'phone'">
                <form onsubmit="return false;" novalidate>
                    <div class="form-group" :class="{'has-error':errors.has('phone')}">
                        <label class="control-label">手机号码：</label>
                        <div class="controls">
                            <input name="phone" v-validate="rules.phone" class="form-control" type="text"
                                   v-model="form.phone" autocomplete="off">
                            <span v-show="errors.has('phone')" class="error-message">{{ errors.first('phone') }}</span>
                        </div>
                    </div>
                    <div class="form-group" :class="{'has-error':errors.has('verifyCode')}">
                        <label class="control-label">验证码：</label>
                        <div class="controls">
                            <div class="input-group">
                                <input name="verifyCode" v-validate="rules.verifyCode" class="form-control" type="text"
                                       v-model="form.verifyCode" autocomplete="off">
                                <div class="input-group-btn">
                                    <button class="btn btn-default" @click="sendVerifyCode" :disabled="!verify.canSend">{{verify.text}}
                                    </button>
                                </div>
                            </div>
                            <span v-show="errors.has('verifyCode')" class="error-message">{{ errors.first('verifyCode') }}</span>
                        </div>
                    </div>
                    <div class="form-group">
                        <button type="submit" class="btn btn-block btn-primary" @click="login" :disabled="isLoading">
                            登录
                        </button>
                    </div>
                    <div class="error-message text-center">
                        <label>{{status}}</label>
                    </div>
                </form>
                <div class="text-center">
                    <a href="javascript:;" @click="mode = 'qrcode'">微信扫码登录</a>
                </div>
                <el-dialog width="400px"
                           :close-on-click-modal="false"
                           :close-on-press-escape="false"
                           :visible.sync="showChooseEntDlg">
                    <form>
                        <div class="form-group">
                            <label class="control-label">请选择您本次登录的企业：</label>
                            <div class="controls">
                                <select v-model="entId" class="form-control">
                                    <option v-for="ent in ents" :value="ent.id">{{ent.name}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group">
                            <button type="button" class="btn btn-block btn-primary" @click="doChooseEnt" :disabled="isLoading">
                                确定
                            </button>
                        </div>
                    </form>
                </el-dialog>
            </div>

            <div v-else-if="mode == 'qrcode'">
                <QrConnect @success="qrConnectSucess()"></QrConnect>
                <div class="text-center">
                    <a href="javascript:;" @click="mode = 'account'">账号密码登录</a>
                    <a href="javascript:;" @click="mode = 'phone'">验证码登录</a>
                </div>
            </div>

        </div>

    </div>
</template>

<script type="text/ecmascript-6">
    import {mapGetters, mapState} from 'vuex'
    import QrConnect from './QrConnect.vue'

    export default {
        components: {QrConnect},
        props: {
            value: Object
        },
        data() {
            return {
                isInDialog: this.value && this.value.isInDialog,
                mode: 'account',
                form: {
                    phone: '',
                    verifyCode: '',
                    password: ''
                },
                verify: {
                    canSend: true,
                    text: "获取验证码"
                },
                status: '',
                showChooseEntDlg: false,
                ents: [],
                entId: '',
                rules: {
                    phone: {
                        required: {message: '请输入手机号'},
                        mobilePhone: true
                    },
                    verifyCode: {
                        required: {message: '请输入验证码'}
                    },
                    account: {
                        required: {message: '请输入账号'}
                    },
                    password: {
                        required: {message: '请输入密码'}
                    }
                }

            }
        },
        mounted() {
            this.inSendVerifyCodeTime(true);
        },
        computed: {
            ...mapState([
                'isLoading',
            ]),
        },
        methods: {
            sendVerifyCode() {
                this.$validator.validate('phone').then(result => {
                    if (!result) {
                        return;
                    }
                    if (!this.verify.canSend) {
                        return;
                    }

                    this.verify.canSend = false;
                    this.$http
                        .post(`/api/account/sendVerifyCode?phone=${this.form.phone}`)
                        .then(({data}) => {
                            //console.log('res', data);
                            this.verify.canSend = false;
                            if (data.success) {
                                this.$layer.success('验证码已发送至您的手机');
                                this.inSendVerifyCodeTime(false);
                            } else {
                                this.verify.canSend = true;
                                this.$layer.alert(data.errorMsg)
                            }
                        })
                        .catch((res) => {
                            this.verify.canSend = true;
                        });

                });
            },
            inSendVerifyCodeTime(isRefresh) {
                var secends = 60;
                if (isRefresh) {
                    var localSecends = localStorage.getItem("loginSecends");
                    if (localSecends) {
                        secends = parseInt(localSecends);
                    } else {
                        secends = null;
                    }
                }
                if (secends != null) {
                    var _this = this;
                    this.verify.canSend = false;
                    this.timer = setInterval(function () {
                        _this.verify.text = secends + " S 后重新获取";
                        secends--;
                        if (secends <= 0) {
                            _this.verify.text = " 获取验证码";
                            localStorage.removeItem("loginSecends");
                            _this.verify.canSend = true;
                            clearInterval(_this.timer);
                            _this.timer = null;
                        } else {
                            localStorage.setItem("loginSecends", secends);
                        }
                    }, 1000);
                }
            },

            loadEnts() {
                this.$http.get("/api/account/getEntList").then(({data}) => {
                    this.ents = data.data;
                    if (this.ents.length) {
                        this.entId = this.ents[0].id;
                    }
                });
            },

            login() {
                if (this.isLoading) {
                    return;
                }
                this.$validator.validateAll().then((result) => {
                    if (!result) {
                        return;
                    }

                    this.status = '正在登录,请稍候...';

                    this.$http.post(`/api/account/login?phone=${this.form.phone}&verifyCode=${this.form.verifyCode}`)
                        .then(({data}) => {
                            if (data.success) {
                                this.status = '登录成功, 正在跳转...';
                                this.loginSuccess()
                            } else if (data.errorCode === 40009) {
                                //多个企业, 需要进一步选择
                                this.status = ''
                                this.loadEnts();
                                this.showChooseEntDlg = true;
                            } else {
                                this.status = data.errorMsg
                            }
                        });
                });
            },
            doChooseEnt() {
                if (!this.entId) {
                    return this.$layer.alert('请选择企业')
                }
                this.$http.post(`/api/account/chooseEnt?entId=${this.entId}`)
                    .then(({data}) => {
                        //console.log('res', data);
                        if (data.success) {
                            this.showChooseEntDlg = false;
                            this.status = '登录成功, 正在跳转...';
                            this.loginSuccess()
                        } else {
                            this.$layer.alert(data.errorMsg)
                        }
                    });
            },
            loginSuccess() {
                if (this.isInDialog) {
                    this.$emit('confirm');
                    return;
                }
                this.$router.replace({
                    path: this.$route.query.returnUrl || '/',
                })
            },
            qrConnectSucess() {
                this.loginSuccess()
            },
            loginByAccount() {//账号登录
                if (this.isLoading) {
                    return;
                }
                this.status = '正在登录,请稍候...';
                this.$http.post(`/api/account/loginByAccount?account=${this.form.account}&password=${this.form.password}`)
                    .then(({data}) => {
                        if (data.success) {
                            this.status = '登录成功, 正在跳转...';
                            this.loginSuccess()
                        } else if (data.errorCode === 40009) {
                            this.status = ''
                        } else {
                            this.status = data.errorMsg
                        }
                    });
            },
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss">
    .page-login {
        background: #f4f4f4;
        margin: -1px -20px;
        padding: 35px;
        height: 100%;
        .login-panel {
            max-width: 420px;
            margin: 0 auto;
            position: relative;
            top: 45%;
            transform: translateY(-50%);
            background: #FFF;
            border-right: 2px solid #E8E8E8;
            border-bottom: 2px solid #E8E8E8;
            border-radius: 2px;
            padding: 50px 50px;
        }

        .el-dialog__body .login-panel {
            border: none;
            margin: 0 auto;
            padding: 0 20px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/modules/account/Login.vue